import { render, staticRenderFns } from "./EditorPanel.vue?vue&type=template&id=2253a434&scoped=true"
import script from "./EditorPanel.vue?vue&type=script&lang=js"
export * from "./EditorPanel.vue?vue&type=script&lang=js"
import style0 from "./EditorPanel.vue?vue&type=style&index=0&id=2253a434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2253a434",
  null
  
)

export default component.exports